import { useStrings } from "@1js/localization-components";
import {
  DisplayCategoryKey,
  NoSearchResults,
  PromptTabs,
  SearchWentWrong,
  type CollectionFilterKeyType,
} from "@1js/pl-card-components";
import * as React from "react";
import { MetaOSAppContext } from "../../pages/metaos/MetaOSAppContext";
import { BrowseCollectionByTaskHeader } from "../../pages/metaos/v2/Home.web.strings";
import type { SearchResultsData } from "../../types";
import { PromptHeadingV2 } from "../AllPrompts/PromptHeadingV2";
import { NoWorkPlacePromptResults } from "../AllPrompts/WorkplacePrompts/NoWorkPlacePromptResults";
import BrowseByGridContainer from "../BrowseBy/BrowseByGridContainer.web";

type CollectionsContentSectionProps = {
  searchResultsData: SearchResultsData | undefined;
  onCollectionTileClick?: (
    filterKey: CollectionFilterKeyType,
    item: string
  ) => void;
  isMetaOsV2HomePage?: boolean;
  selectedTab?: PromptTabs;
  promptsLength?: number;
  titleOverride?: string;
};

export const CollectionsContentSection: React.FC<
  CollectionsContentSectionProps
> = ({
  searchResultsData,
  onCollectionTileClick,
  isMetaOsV2HomePage,
  selectedTab,
  promptsLength,
  titleOverride,
}) => {
  const metaOSAppContext = React.useContext(MetaOSAppContext);
  const localizations = useStrings({
    BrowseCollectionByTaskHeader,
  });

  return (
    <>
      <PromptHeadingV2
        navItem={selectedTab ?? PromptTabs.CombinedPrompts}
        searchResultsData={searchResultsData}
        isMetaOsV2HomePage={isMetaOsV2HomePage}
        titleOverride={titleOverride}
      />
      {selectedTab === PromptTabs.WorkplacePrompts && promptsLength == 0 && (
        <NoWorkPlacePromptResults />
      )}
      {searchResultsData &&
        searchResultsData.queryText &&
        searchResultsData.numOfResults === 0 &&
        !searchResultsData.searchError && (
          <>
            <NoSearchResults />
            <BrowseByGridContainer
              //eslint-disable-next-line @typescript-eslint/no-empty-function
              onBrowseByClick={onCollectionTileClick ?? (() => {})}
              type={DisplayCategoryKey}
              items={metaOSAppContext.categories}
              title={localizations.BrowseCollectionByTaskHeader()}
            />
          </>
        )}
      {searchResultsData &&
        searchResultsData.queryText &&
        searchResultsData.searchError && <SearchWentWrong />}
    </>
  );
};
